export default __webpack_public_path__ + "d188b67544c5269f09117bad133559f0.svg";